import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import MoveToCsModalUI from './MoveToCsModalUI.js'

class MoveToCsModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dueDate: null,
      submitted: false,
      successMsg: null,
      errorList: []
    }
  }

  componentDidUpdate(prevProps) {
    // Reset state when modal is opened
    if (this.props.moveMode && !prevProps.moveMode) {
      this.setState({
        dueDate: null,
        submitted: false,
        successMsg: null,
        errorList: []
      })
    }
  }

  render() {
    return (
      <MoveToCsModalUI
        context={this.props.context}
        loan={this.props.loan}
        moveMode={this.props.moveMode}
        onCancelClick={this.props.onCancelClick}
        selectedFileCode={this.props.selectedFileCode}
        //
        dueDate={this.state.dueDate}
        onDueDateChange={this.onDueDateChange}
        //
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        onSubmitClick={this.onSubmitClick}
      />
    )
  }

  onDueDateChange = (name, value) => {
    // Handle both (name, value) and (value) parameter styles
    const dateValue = value !== undefined ? value : name

    console.log('Date changed:', dateValue)

    this.setState({
      dueDate: dateValue,
      errorList: [] // Clear errors when date is selected
    })
  }

  onSubmitClick = () => {
    if (!this.state.dueDate) {
      this.setState({
        errorList: ['Please select a due date']
      })
      return
    }

    // Convert ISO date string to timestamp (milliseconds since epoch)
    const dueDateTimestamp = new Date(this.state.dueDate).getTime()

    this.setState({
      submitted: true,
      successMsg: null,
      errorList: []
    })

    console.log('Moving to CS - dueDate:', this.state.dueDate, 'timestamp:', dueDateTimestamp)

    // API expects request body with dueDate field (as timestamp string)
    RestApiUtils.put(
      this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/cpdocuments/${this.props.selectedFileCode}/moveToCSDocuments`,
      this.onSubmitClickCallback,
      {
        dueDate: dueDateTimestamp.toString()
      }
    )
  }

  onSubmitClickCallback = (response) => {
    console.log('Move to CS Response:', response)

    let errorList = []
    if (response.errorList && response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (errorList.length === 0) {
      // Success - refresh and close modal
      setTimeout(() => {
        this.props.onRefreshClick('noBusy')
        this.props.onCancelClick()
      }, 1000)
    }
  }
}

export default MoveToCsModalSF